import axios from "axios";

import { urlFileApi } from "./apiUpload";
import { ImageSize } from "./ImageSize";

export const urlForDownload = (
  id: string,
  image: ImageSize | boolean,
): string =>
  axios.getUri({
    url: urlFileApi(),
    params: {
      path: id,
      type: image ? "IMAGE" : "FILE",
      imageSize: typeof image === "string" ? image.toUpperCase() : undefined,
    },
  });

export const imgSrc = (id: string, size?: ImageSize): string =>
  urlForDownload(id, size ?? true);
